import store from '../../../store/store';
import { BaseComponent } from '../../base-component/base-component';
import { DocumentType, ProductType } from '../../product-card/interfaces/product-card.interface';
import { ProductCardData } from '../../product-card/product-card-display';
import { SearchResultItem } from '../interfaces/search-result.interface';
import { connect } from 'pwa-helpers';
import { html, nothing } from 'lit';
import { property } from 'lit/decorators.js';

export class BaseView extends connect(store)(BaseComponent) {
  /**
   * A product card data array.
   */
  @property({type: Array})
  products?: Array<ProductCardData>;

  /**
   * Renders the search results based on the type.
   */
  renderSearchResults(viewName: string) {
    if (!this.products) {
      return nothing;
    }

    return html`
      <div id=${viewName} class="${viewName}-container">
        ${this.products?.map((item, index, products) => {
          const searchResultItem: SearchResultItem = {
            product: item,
            isLast: index === products.length - 1
          }

          switch (item.type) {
            case ProductType.he:
              return this.renderHeProduct(searchResultItem);
            case ProductType.segProduct:
            case ProductType.segProgram:
              return this.renderProductOrProgram(searchResultItem);
            default:
              return nothing;
          }
        })}
      </div>
    `;
  }

  /**
   * Renders the product or program view for SEG results.
   *
   * @param searchResultItem
   * @private
   */
  private renderProductOrProgram(searchResultItem: SearchResultItem) {
    switch (searchResultItem.product.documentType) {
      case DocumentType.products:
        return this.renderK12Product(searchResultItem);
      case DocumentType.programs:
        return this.renderK12Program(searchResultItem);
      default:
        return nothing;
    }
  }

  /**
   * Renders a HE product.
   * To be implemented for each view.
   */
  renderHeProduct(_searchResultItem: SearchResultItem) {
    throw new Error('Method not implemented.');
  }

  /**
   * Renders a K12 product.
   * To be implemented for each view.
   */
  renderK12Product(_searchResultItem: SearchResultItem) {
    throw new Error('Method not implemented.');
  }

  /**
   * Renders a K12 program.
   * To be implemented for each view.
   */
  renderK12Program(_searchResultItem: SearchResultItem) {
    throw new Error('Method not implemented.');
  }
}
